<template>
  <div class="plate-home">
    <div class="plate-home__sticky">
      <div v-if="showBanner" class="bannerWrap">
        <swiperComponents :adData="adData"></swiperComponents>
        <!-- <div class="bannerClose" @click="handleCloseBanner">
          <van-icon name="cross" />
        </div> -->
      </div>
      <div class="platelist">
        <img class="plateIcon" :src="require('../../assets/img/platelistIcon.png')" alt="" />

        <van-tabs
          class="indexvantabs"
          v-model="plateListactive"
          title-active-color="#383838"
          title-inactive-color="#2A82E4"
          line-height="0"
          background="transparent"
          :ellipsis="false"
          :sticky="true"
        >
          <van-tab v-for="(item, index) in plateList" :title="item.name" :key="index"></van-tab>
        </van-tabs>
      </div>
      <div class="allSearch">
        <div @click="onSearch" class="searchbox">
          <van-icon size="20" name="search" />
          <span class="line"></span>
          请输入内容，开始任性搜索
        </div>
      </div>
    </div>
    <div v-if="plateList.length" class="sectionList">
      <div
        v-for="(it, index) in plateList[plateListactive].children"
        :key="index"
        @click="gridBack(it, plateList[plateListactive].name)"
        class="row"
      >
        <div class="ltitle">{{ it.name }}</div>
        <div class="desc">
          <div class="jrt">今日贴：{{ it.daycount }}</div>
          <div class="jrt">主题帖：{{ it.onlineCount }}</div>
          <div class="jrt">发帖总数：{{ it.allcount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSectionList, queryHotPosts } from '@/api/base';
import swiperComponents from '../components/swiper.vue';
export default {
  components: {
    swiperComponents,
  },
  name: 'index',
  data() {
    return {
      value: '全部版块',
      showPicker: false,
      plateList: [],
      plateListChildren: [],
      ruleFrom: {
        code: null,
        searchContent: null,
        onlineCount: null,
      },
      topHotList: [],
      adData: this.$store.state.app.adBanner.list,
      plateListactive: 0,
      // 记录 banner 是否展示，默认展示
      showBanner: true,
    };
  },
  watch: {},
  created() {
    this.init();
  },

  methods: {
    handleCloseBanner() {
      // 仅在当前页面实例内关闭 banner，不做持久化
      this.showBanner = false;
    },
    init() {
      getSectionList().then(res => {
        if (res.data.length == 0) {
          let str = window.localStorage.getItem('plateList');
          res.data = JSON.parse(str);
        }
        this.plateList = res.data.sort((a, b) => a.sortno - b.sortno);
        this.plateList.map(item => {
          item.children.sort((a, b) => a.sortno - b.sortno);
        });
        this.plateListChildren = this.plateList[0];
        // this.plateList.unshift({
        //   name: '全部',
        //   code: null,
        //   children: [{ name: '全部', code: null }],
        // });
        if (res.data.length > 0) {
          window.localStorage.setItem('plateList', JSON.stringify(this.plateList));
        }
      });
      queryHotPosts({ size: 10, current: 1 }).then(res => {
        this.topHotList = res.data;
      });
    },
    gridBack(item, name) {
      item.parentsName = name;
      this.$router.push({ path: '/plate/list', query: item });
    },
    onConfirm(value, e) {
      console.log(value, e);
      this.ruleFrom.code = this.plateList[e[0]].children[e[1]].code;
      this.ruleFrom.name = this.plateList[e[0]].children[e[1]].name;
      this.value = value;
      if (value.indexOf('全部') != -1) {
        this.value = '全部版块';
      }
      this.ruleFrom.onlineCount = this.plateList[e[0]].children[e[1]].onlineCount;

      console.log(this.ruleFrom);
      this.showPicker = false;
    },
    onSearch() {
      // if (
      //   this.$store.state.app.userinfos.isVip == 1 &&
      //   this.$store.state.app.userinfos.vipExpireTime
      // ) {
      //   this.$router.push({ path: '/plate/list', query: this.ruleFrom });
      // } else {
      //   this.$dialog
      //     .confirm({
      //       title: '暂未开通会员',
      //       confirmButtonText: '开通会员',
      //       cancelButtonText: '取消',
      //     })
      //     .then(() => {
      //       // on confirm
      //       this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
      //     })
      //     .catch(() => {
      //       // on cancel
      //     });
      // }
      this.$router.push({ path: '/plate/list', query: this.ruleFrom });
    },
    gridBackRegistry() {
      this.$router.push({ path: '/ycRegistry' });
    },
    backHot() {
      this.$router.push({ path: '/hot' });
    },
  },
};
</script>
<style lang="less" scoped>
.bannerWrap {
  position: relative;
  overflow: hidden;
}
.bannerClose {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  font-size: 12px;
}
.plate-home__sticky {
  position: sticky;
  top: 0;
  z-index: 99;
  background: #fff;
}
.platelist {
  padding: 0px 10px;
  background: linear-gradient(0deg, rgba(255, 241, 235, 1) 0%, rgba(172, 224, 249, 1) 100%);
  line-height: 27px;
  font-size: 14px;
  display: flex;
  align-items: center;
  .plateIcon {
    width: 16px;
    height: 16px;
    // margin-right: 6px;
  }
}
.allSearch {
  padding: 0 3px;
  .searchbox {
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(229, 229, 229, 1);
    box-shadow: 0px 0px 25.5px rgba(242, 245, 233, 1);
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 16.46px;
    color: rgba(166, 166, 166, 1);
    display: flex;
    align-items: center;
    padding: 8px;
    margin-top: 4px;
    .line {
      border-right: 1px solid rgba(166, 166, 166, 1);
      margin: -3px 8px;
      display: block;
      height: 18px;
    }
  }
}
.sectionList {
  .row {
    padding: 13px 20px 10px 20px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 0px 25.5px #f2f5e9;
    .ltitle {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 21.95px;
      color: rgba(56, 56, 56, 1);
      text-align: left;
      vertical-align: middle;
      margin-bottom: 11px;
    }
    .desc {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 17.84px;
      color: rgba(166, 166, 166, 1);
      text-align: left;
      vertical-align: middle;
    }
  }
}
</style>

<style>
.indexvantabs .van-tabs__wrap--scrollable .van-tab {
  padding: 0 4px;
  text-decoration: underline;
}
.indexvantabs .van-tabs__wrap--scrollable .van-tab.van-tab--active {
  text-decoration: dashed;
}
</style>
